import {PdsWidget} from './pds-widget';
let isIntegerRegex = /^([-]?[0-9]*)?$/;

export class PdsProgressBarWidget extends PdsWidget {
  is = 'pds-progress-bar-widget';

  width: number;
  dataShowText: string;

  properties = {
    width: {
        type: Number,
        value: 0,
        notify: true,
        reflectToAttribute: true
    },
    dataShowText: {
      type: String,
      value: 'true'
    }
  };

  validateWidget(): boolean {
    return true;
  }
}
